import { MDXRenderer } from 'gatsby-plugin-mdx';
import React from 'react';

/** @public */
function PropDescription(_ref) {
  var mdx = _ref.mdx,
      html = _ref.html,
      _ref$as = _ref.as,
      Tag = _ref$as === void 0 ? 'div' : _ref$as;
  if (mdx) return /*#__PURE__*/React.createElement(Tag, null, /*#__PURE__*/React.createElement(MDXRenderer, null, mdx.body));
  return /*#__PURE__*/React.createElement(Tag, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
}

export default PropDescription;